<template>
    <v-container fluid>
        <v-layout v-if="!!lastRound">
            <v-flex>
                <app-last-round-card />
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12>
                <app-title>Iniciar Rondas</app-title>
            </v-flex>
        </v-layout>
        <v-layout v-for="round in filteredRounds" :key="round.id" column mb-2>
            <app-round-info :round="round" @start="onStart" />
        </v-layout>
    </v-container>
</template>
<script>
import RoundInfo from '../components/widgets/RoundInfo'
import { mapMutations, mapActions } from 'vuex'
import LastRoundCard from '../components/widgets/LastRoundCard'

export default {
    components: {
        appRoundInfo: RoundInfo,
        appLastRoundCard: LastRoundCard,
    },
    computed: {
        filteredRounds() {
            return this.rounds.filter(item => item.venue_id === this.venue.id)
        },
    },
    methods: {
        ...mapActions(['startRound']),
        ...mapMutations({
            setCurrentRound: 'currentRound',
            setRoundInProgress: 'roundInProgress',
        }),
        onStart(round) {
            const startDate = this.$dt.now()

            this.setCurrentRound(round)

            // const checklistItems = [];
            // round.check_list.map(item => checklistItems.push({id: item.id, value: false}));

            // const roundInProgress = {...this.roundInProgress, startDate, userId: this.user.id, checklistItems };
            const roundInProgress = { ...this.roundInProgress, startDate, userId: this.user.id }

            // Iniciar la ronda asincronamente
            this.startRound({ roundId: round.id, startDate, userId: this.user.id }).then(resp =>
                this.setRoundInProgress({ ...this.roundInProgress, id: resp.instance.id })
            )

            this.setRoundInProgress(roundInProgress)

            this.$router.push({ name: 'roundInProgress' })
        },
    },
}
</script>
